export const LEADS_TYPES = ["Institución", "General", "Alumno", "Empresa", "Otro"]
export const LEADS_METHODS = ["Whatsapp", 'E-mail', 'Linkedin', 'Redes', 'Telegram', "Web", "YouTube"]
export const LEADS_CAMPAIGN = ['Voluntario', 'Acción mailing', 'Acción publicación', "Beneficiarios", "Interna", "Recontacto"]
export const LEADS_OUTCOME = [
    { value: 'PENDING', label: "Pendiente" },
    { value: 'SUCCESS', label: "Exitoso" },
    { value: 'FAILED', label: "Fallido" },
    { value: 'AUTO-FAILED', label: "Fallido automático" },
]

export const LEADS_STATUS = [{ value: 'NEW', label: "Nuevo usuario" }, { value: "CONTACTED", label: "Contactado" }, { value: 'CONVERTED', label: 'Convertido' }, { value: "DISQUALIFIED", label: "Desclasficiado" }]


export const LEAD_SOURCES = {
    "CONTACT-FORM": "Formulario de contacto",
    "DEMO-BUTTON": "Demo del campus",
    "DEMO-SECTION": "Demo del campus en detalles",
    "SORTEO_PAGE": "Sorteo",
    "ADVISOR_MODAL": "Modal",
    "CATALOGO": "Descarga de catálogo",
}